<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        Maatregel splitsen
    </h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="search-list">
        <div class="search-item">
            <div class="check">

            </div>
            <div class="image" app-svg-as-img [ttm]="ttm"></div>
            <div class="info justify-content-between">
                <div class="ps-0 ps-sm-4">
                    <div class="d-flex justify-content-between">
                        <div>
                            #{{ttm.id}}
                        </div>
                        <small *ngIf="ttm.type?.count"><i class="fa fa-calculator "></i> {{checkedCount ?? 1}}</small>
                    </div>
                    <small>{{(ttmTypes | byKey : ttm.type_key)?.name}}</small>
                </div>
                <div>
                    <app-status-chip class="mt-1 me-3" [statusKey]="ttm?.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="items">
            @for (entity of ttm.entities; track entity.id) {
                <div matRipple class="search-item" (click)="$event.stopPropagation(); checked.controls[entity.id].setValue(!checked.value[entity.id]);">
                    <div class="check">
                        <mat-checkbox [checked]="checked.value[entity.id]"></mat-checkbox>
                    </div>
                    <div class="image" app-svg-as-img [svg]="entity.projected_image?.svg"></div>
                    <div class="info justify-content-between">
                        <div class="ps-0 ps-sm-4">
                            <div class="d-flex justify-content-between">
                                <div>
                                    {{entity.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button mat-button type="button" mat-dialog-close>Sluiten</button>
    <button mat-raised-button color="primary" type="button" (click)="split()" [disabled]="checkedCount === ttm.entities.length">
        Splitsen
    </button>
</mat-dialog-actions>
